export const getReversePickListSetting = () => {
  try {
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      const user = JSON.parse(userInfo);
      if (user.current_tenant && user.name) {
        const storageKey = `${user.current_tenant}-${user.name}-reversePickList`;
        return localStorage.getItem(storageKey) === 'true';
      }
    }
  } catch (e) {
    console.error('Error getting reverse pick list setting:', e);
  }
  return localStorage.getItem('reversePickList') === 'true';
};

